import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const EditSmallIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M6 10.4253C6 10.1278 6.11822 9.84235 6.32864 9.63192L9.80485 6.15571C9.38658 6.05394 8.94959 6 8.5 6C5.46243 6 3 8.46243 3 11.5C3 14.5376 5.46243 17 8.5 17C11.5376 17 14 14.5376 14 11.5C14 11.0504 13.9461 10.6134 13.8443 10.1951L10.3681 13.6714C10.1576 13.8818 9.87225 14 9.57466 14H7.12206C6.50237 14 6 13.4976 6 12.8779V10.4253ZM15.4249 8.61457C15.7954 9.50278 16 10.4775 16 11.5C16 15.6421 12.6421 19 8.5 19C4.35786 19 1 15.6421 1 11.5C1 7.35786 4.35786 4 8.5 4C9.5225 4 10.4972 4.20462 11.3854 4.57514L14.6319 1.32865C15.0701 0.890452 15.7806 0.890452 16.2188 1.32864L18.6714 3.78124C19.1096 4.21943 19.1095 4.92988 18.6714 5.36808L15.4249 8.61457ZM8 10.789L13.6814 5.10755L14.9043 6.30673L9.21101 12H8V10.789ZM15.0957 3.69327L16.3186 4.89245L16.6363 4.57466L15.4253 3.36365L15.0957 3.69327Z"
    fill="currentColor"
  />,
  "EditSmallIcon"
);
(EditSmallIcon as React.ComponentType).defaultProps = {
  viewBox: "0 0 20 20",
};
